module.exports = __webpack_public_path__ + "static/media/The-West-Subscription-EOFY.6ebc145f.png";